export const POPULATE = 'FirewallLogsPopulate'

export const SET_LOADED = 'FirewallLogsSetLoaded'

export const SET_FILTERS = 'FirewallLogsSetFilters'

export const SET_FORMAT = 'FirewallLogsSetFormat'
export const SET_FORMAT_LIST = 'FirewallLogsSetFormatList'
export const SET_FORMAT_PAGINATION = 'FirewallLogsSetFormatPagination'